import React from "react";
import {
    Box,
    Typography,
    Grid,
    Card,
    Button,
    Avatar,
    styled,
} from "@mui/material";

import LaunchIcon from "@mui/icons-material/Launch";
import CodeIcon from "@mui/icons-material/Code";

/* Premium Background */
const bgImage =
    "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5";

/* Styled Components */
const PageWrapper = styled(Box)(({ theme }) => ({
    minHeight: "100vh",
    backgroundImage: `linear-gradient(rgba(16,7,32,0.90), rgba(16,7,32,0.95)), url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    paddingTop: "120px",
    paddingBottom: "80px",
    color: "white",
}));

const GlassCard = styled(Card)(({ theme }) => ({
    backgroundColor: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(10px)",
    borderRadius: "14px",
    padding: "25px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
    transition: "0.3s",
    "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
    },
}));

const IconWrapper = styled(Avatar)(({ theme }) => ({
    backgroundColor: "goldenrod",
    color: "#100720",
    width: 60,
    height: 60,
}));

/* Updated Final Project Data */
const projects = [
    {
        id: 1,
        title: "Fullstack Car Hiring App",
        desc: "React + Spring Boot + Authentication + Admin Dashboard.",
        link: "https://carhiringapp.netlify.app/",
    },
    {
        id: 2,
        title: "Book Management System",
        desc: "Angular + Spring Boot + CRUD + Cloud Deployment.",
        link: "https://bookmanagerapp-f4df2.web.app/home",
    },
    {
        id: 3,
        title: "Python Data Dashboard",
        desc: "Flask + Pandas + Chart.js + REST API.",
        link: "",
    },
    {
        id: 4,
        title: "Portfolio Landing Page",
        desc: "React + AWS CloudFront + Responsive UI.",
        link: "https://d288m8bluvx5fy.cloudfront.net/",
    },
];

export default function ProjectList() {
    return (
        <PageWrapper>
            {/* Golden Banner Title */}
            <Box sx={{ textAlign: "center", mb: 6 }}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 800,
                        backgroundColor: "goldenrod",
                        color: "#100720",
                        px: 4,
                        py: 1,
                        borderRadius: "999px",
                        display: "inline-block",
                    }}
                >
                    Final Projects
                </Typography>
            </Box>

            {/* Projects Grid */}
            <Box sx={{ width: "100%", maxWidth: "1200px", mx: "auto" }}>
                <Grid container spacing={4} justifyContent="center">
                    {projects.map((p) => (
                        <Grid item xs={12} sm={6} md={4} key={p.id}>
                            <GlassCard>
                                <IconWrapper>
                                    <CodeIcon />
                                </IconWrapper>

                                {/* Title */}
                                <Typography
                                    variant="h5"
                                    sx={{ fontWeight: 700, color: "#100720", mt: 2 }}
                                >
                                    {p.title}
                                </Typography>

                                {/* Description */}
                                <Typography sx={{ color: "#333", mt: 1 }}>
                                    {p.desc}
                                </Typography>

                                {/* Link or Coming Soon */}
                                {p.link ? (
                                    <Button
                                        variant="contained"
                                        endIcon={<LaunchIcon />}
                                        href={p.link}
                                        target="_blank"
                                        sx={{
                                            backgroundColor: "goldenrod",
                                            color: "#100720",
                                            fontWeight: "bold",
                                            mt: 3,
                                            borderRadius: "8px",
                                            "&:hover": { backgroundColor: "#e0b200" },
                                        }}
                                    >
                                        View Project
                                    </Button>
                                ) : (
                                    <Typography
                                        sx={{
                                            color: "gray",
                                            fontStyle: "italic",
                                            mt: 3,
                                            textAlign: "center",
                                        }}
                                    >
                                        Coming soon
                                    </Typography>
                                )}
                            </GlassCard>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </PageWrapper>
    );
}
